// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"63":"abe18aed","151":"849a5223","546":"2da93878","793":"7df239e3","960":"d1021923"}[chunkId] + ".js";
};